
<script>
import {
  rexRoundedSingleSelect,
  rexRoundedAutocomplete,
  rexRoundedDate
} from '@/components/views/rexRoundedField'

export default {
  name: 'aviaticket-form',
  components: {
    rexRoundedSingleSelect,
    rexRoundedAutocomplete,
    rexRoundedDate
  },
  props: {
    formIsShown: {
      type: Boolean,
      default: () => true
    },
    resultIsShown: {
      type: Boolean,
      default: () => false
    },
    flightIndex: {
      type: Number,
      required: true
    }
  },
  data: () => ({
    flightClass: [
      {
        slug: 'ANY',
        name: 'Любой'
      },
      {
        slug: 'ECONOMY',
        name: 'Эконом'
      },
      {
        slug: 'BUSINESS',
        name: 'Бизнесс'
      },
      {
        slug: 'FIRST',
        name: 'Первый'
      }
    ],
    transfersCount: [
      {
        slug: 0,
        name: 'Без/Прямые'
      },
      {
        slug: 1,
        name: 'Не более 1'
      },
      {
        slug: 2,
        name: 'Не более 2'
      },
      {
        slug: 3,
        name: 'Больше 2'
      }
    ]
  }),
  computed: {
    getHotelForm() {
      return this.$store.getters['cart/getHotelForm']
    },
    getDates() {
      return this.$store.getters['cart/getDates']
    },
    getQuotasDates() {
      return this.$store.getters['cart/getFlightQuotasDates'](this.flightIndex)
    }
  },
  watch: {
    getDates: {
      // eslint-disable-next-line
      handler: function () {
        this.setAviaticketDates(this.getDates)
      },
      deep: true
    }
  },
  created() {
    this.setAviaticketDates(this.getDates)
  },
  methods: {
    search() {
      this.$parent.formIsShown = false
      this.$parent.resultIsShown = true

      this.$store.commit('cart/updateServiceModuleIsLoading', {
        status: true,
        target: `flights.${this.flightIndex}.aviatickets`
      })

      this.$store.commit('cart/updateIsCollectionLoading', {
        flightIndex: this.flightIndex,
        status: true
      })

      this.$store.dispatch('cart/getFlights', {
        flightIndex: this.flightIndex,
        form: {
          ...this.$store.getters['cart/getFlightFormForSearch'](this.flightIndex),
          page: 1
        }
      })
    },
    setAviaticketDates({ startDate, endDate }) {
      this.$store.commit('cart/updateServiceField', {
        target: `flights.${this.flightIndex}.form.startDate`,
        value: startDate
      })

      this.$store.commit('cart/updateServiceField', {
        target: `flights.${this.flightIndex}.form.endDate`,
        value: endDate
      })
    },
    getFlightQuotasDates() {
      const {
        cityFrom: {
          slug: placeFromId,
          code: placeFromType
        },
        cityTo: {
          slug: placeToId,
          code: placeToType
        },
        startDate,
        endDate
      } = this.$store.getters['cart/getFlightForm'](this.flightIndex)

      const payload = {
        placeFromId,
        placeFromType,
        placeToId,
        placeToType,
        startDate,
        endDate
      }

      if (placeFromId && placeToId) {
        this.$store.dispatch('cart/getFlightQuotasDates', payload)
      }
    }
  }
}
</script>

<template>
  <div class="cart__aviaticket">
    <div
      class="cart__search-form--row"
    >
      <rex-rounded-autocomplete
        label="Город вылета"
        store-module="cart"
        getter-name="getServiceField"
        setter-name="updateServiceField"
        :target="`flights.${flightIndex}.form.cityFrom`"
        :css-class="resultIsShown ? 'cart__search-form--w14-83' : 'cart__search-form--w12'"
        endpoint="avia"
        :disabled="resultIsShown"
        @onChange="getFlightQuotasDates"
      />
      <rex-rounded-autocomplete
        label="город прибытия"
        store-module="cart"
        getter-name="getServiceField"
        setter-name="updateServiceField"
        :target="`flights.${flightIndex}.form.cityTo`"
        :css-class="resultIsShown ? 'cart__search-form--w14-83' : 'cart__search-form--w12'"
        endpoint="avia"
        :disabled="resultIsShown"
        @onChange="getFlightQuotasDates"
      />
      <rex-rounded-date
        label="Туда"
        store-module="cart"
        getter-name="getServiceField"
        setter-name="updateServiceField"
        :target="`flights.${flightIndex}.form.startDate`"
        :css-class="resultIsShown ? 'cart__search-form--w14-83' : 'cart__search-form--w12'"
        :disabled="resultIsShown"
        :marks="getQuotasDates.direction"
        :filled-marks="true"
        :legend="[{color: '#55b7a1', label: 'Билеты Русского экспресса'}]"
        @onChange="getFlightQuotasDates"
      />
      <rex-rounded-date
        label="обратно"
        store-module="cart"
        getter-name="getServiceField"
        setter-name="updateServiceField"
        :target="`flights.${flightIndex}.form.endDate`"
        :css-class="resultIsShown ? 'cart__search-form--w14-83' : 'cart__search-form--w12'"
        :disabled="resultIsShown"
        :marks="getQuotasDates.reverseDirection"
        :filled-marks="true"
        :legend="[{color: '#55b7a1', label: 'Билеты Русского экспресса'}]"
        @onChange="getFlightQuotasDates"
      />
      <rex-rounded-single-select
        label="класс"
        store-module="cart"
        getter-name="getServiceField"
        setter-name="updateServiceField"
        :target="`flights.${flightIndex}.form.flightClass`"
        :css-class="resultIsShown ? 'cart__search-form--w14-83' : 'cart__search-form--w12'"
        :hide-if-empty="false"
        :data="flightClass"
        :disabled="resultIsShown"
      />
      <rex-rounded-single-select
        label="пересадки"
        store-module="cart"
        getter-name="getServiceField"
        setter-name="updateServiceField"
        :target="`flights.${flightIndex}.form.transfersCount`"
        :css-class="resultIsShown ? 'cart__search-form--w14-83' : 'cart__search-form--w12'"
        :hide-if-empty="false"
        :data="transfersCount"
        :disabled="resultIsShown"
      />
      <button
        v-if="formIsShown"
        class="rex-btn-main rex-btn-main--h40 cart__search-form--btn-offset"
        @click="search"
      >
        Найти
      </button>
    </div>
  </div>
</template>
